import { render, staticRenderFns } from "./LiveBrowsingRoom.vue?vue&type=template&id=2008f0aa&scoped=true"
import script from "./LiveBrowsingRoom.vue?vue&type=script&lang=js"
export * from "./LiveBrowsingRoom.vue?vue&type=script&lang=js"
import style0 from "./LiveBrowsingRoom.vue?vue&type=style&index=0&id=2008f0aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2008f0aa",
  null
  
)

export default component.exports